import cornerArt from "@assets/images/competition/ramadan/corner.jpg";
import cornerMobileArt from "@assets/images/competition/ramadan/corner-mobile.jpg";

/**
 * Yarışma temaları.
 *
 * Görseller (arka plan, banner, logo, süsler) HER ZAMAN admin'in kaydettiği değerlerden gelir;
 * ön yüz bu görselleri içermez. Admin tema olarak Ramazan'ı seçtiğinde hazır görseller admin
 * panelinden içerik servisine yüklenip forma yazılır. Burada yalnızca boş bırakılan renklerin
 * varsayılanları ve admin'den yönetilmeyen sabit parça (Yarışma Köşesi şablonu) durur.
 */
const THEMES = {
  BLANK: {
    className: "cmp-theme-blank",
    colors: {
      primary: "#1b5e7b",
      text: "#ffffff",
      cardText: "#1f2937",
      choiceIn: "#1b5e7b",
      choiceOut: "#1b5e7b",
    },
  },
  RAMADAN: {
    className: "cmp-theme-ramadan",
    colors: {
      primary: "#c9a04f",
      text: "#ffffff",
      cardText: "#3b2a12",
      choiceIn: "#8a5a1c",
      choiceOut: "#c9a04f",
    },
  },
};

/**
 * Yarışma Köşesi şablonları (admin'den değişmez; köşe sabittir). Web'de yatay, mobilde dikey
 * görsel kullanılır; içerik görseldeki kutulara yazılır, "TIKLAYIN" metni görselin içindedir.
 */
export const CORNER_TEMPLATES = {
  RAMADAN: {
    art: cornerArt,
    mobileArt: cornerMobileArt,
  },
};

export const themeOf = (competition) =>
  THEMES[competition?.themeKey] || THEMES.BLANK;

const cssUrl = (url) =>
  url ? `url("${String(url).replace(/"/g, "%22")}")` : undefined;

/**
 * Sayfa kökü için CSS değişkenleri. Arka plan görselleri de değişkenle verilir; medya sorgusu
 * her cihazda yalnızca kendi görselini uygular (mobil görsel yoksa yatay görsel kullanılır).
 * Soru alanı görselleri birbirinin yerine kullanılmaz: o cihazın görseli yoksa alan beyazdır.
 */
export const themeStyle = (competition) => {
  const theme = themeOf(competition);
  const desktop = cssUrl(competition?.backgroundImageUrl);
  const mobile = cssUrl(competition?.backgroundImageMobileUrl) || desktop;
  const areaDesktop = cssUrl(competition?.questionAreaImageUrl);
  const areaMobile = cssUrl(competition?.questionAreaImageMobileUrl);
  return {
    "--cmp-primary": competition?.primaryColor || theme.colors.primary,
    // Arka planın üstündeki yazılar temadan; admin'in "Yazı rengi" kart içindeki yazılar için
    "--cmp-text": theme.colors.text,
    "--cmp-card-text": competition?.textColor || theme.colors.cardText,
    "--cmp-choice-in": competition?.choiceInColor || theme.colors.choiceIn,
    "--cmp-choice-out": competition?.choiceOutColor || theme.colors.choiceOut,
    ...(desktop ? { "--cmp-bg-desktop": desktop } : null),
    ...(mobile ? { "--cmp-bg-mobile": mobile } : null),
    ...(areaDesktop ? { "--cmp-area-desktop": areaDesktop } : null),
    ...(areaMobile ? { "--cmp-area-mobile": areaMobile } : null),
  };
};

/**
 * Arka plan görseli girildiyse sayfa "sahne" düzeninde çizilir: görsel tam genişlikte durur,
 * soru alanı üstüne sabit boyutta çizilir (web'de kare, mobilde dikey; bkz. styles.scss).
 */
export const isFramed = (competition) =>
  Boolean(competition?.backgroundImageUrl);

export const hasCustomBackground = (competition) =>
  Boolean(
    competition?.backgroundImageUrl || competition?.backgroundImageMobileUrl
  );
